import { useTheme } from "@mui/styles";
import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getAdaptiveFontSize } from "../../utils/styling.utils";

const ModalTitle = ({ children, styles = {}, className = "" }) => {
  const theme = useTheme();
  //Media Queries
  const isSmartphoneScreen = useMediaQuery("(min-width: 0px)");
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmartphoneScreen,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };

  return (
    <div
      className={className}
      style={{
        fontSize: isMediumScreen
          ? getAdaptiveFontSize({
              screenWidthHooks,
              fontSize: 2,
            })
          : "1.5rem",
        fontWeight: "600",
        fontFamily: "noto-sans",
        color: theme.COLORS.BLUE.darkBlueGreen,
        ...styles,
      }}
    >
      {children}
    </div>
  );
};

export default ModalTitle;
